<div class="form-group" [ngClass]="field.customClass">
  <label [for]="'field' + field.name">
    <span>{{ field.label }}</span>
    <span class="text-danger">{{ field.required ? "*" : "" }}</span>
  </label>
  <input
    [name]="field.name"
    [placeholder]="field.inputPlaceholder || ''"
    [formControl]="control"
    class="form-control"
    [class.is-invalid]="(control.touched || control.value) && control.errors"
    [class.is-valid]="control.touched && control.value"
    [id]="'field' + field.name"
    [attr.disabled]="disabled || null"
    (input)="handleInput($event)"
    (paste)="handlePaste($event)"
    #input
  />
</div>
